export default function Pagination({
  currentPage,
  setCurrentPage,
  totalRows,
  pageSize,
}) {
  const totalPages = Math.ceil(totalRows / pageSize);
  if (totalPages <= 1) return null;

  const pageWindow = 2;
  let startPage = Math.max(1, currentPage - pageWindow);
  let endPage = Math.min(totalPages, currentPage + pageWindow);

  if (endPage - startPage < pageWindow * 2) {
    if (startPage === 1)
      endPage = Math.min(totalPages, startPage + pageWindow * 2);
    if (endPage === totalPages)
      startPage = Math.max(1, endPage - pageWindow * 2);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div>
        Showing {startIndex + 1} to {Math.min(endIndex, totalRows)} of{" "}
        {totalRows}
      </div>
      <nav aria-label='pagination'>
        <ul className='pagination mb-0'>
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className='page-link'
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label='Previous'
            >
              Previous
            </button>
          </li>
          {startPage > 1 && (
            <>
              <li className='page-item'>
                <button className='page-link' onClick={() => setCurrentPage(1)}>
                  1
                </button>
              </li>
              {startPage > 2 && (
                <li className='page-item disabled'>
                  <span className='page-link'>…</span>
                </li>
              )}
            </>
          )}
          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <button
                className='page-link'
                onClick={() => setCurrentPage(page)}
                aria-current={currentPage === page ? "page" : undefined}
              >
                {page}
              </button>
            </li>
          ))}
          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && (
                <li className='page-item disabled'>
                  <span className='page-link'>…</span>
                </li>
              )}
              <li className='page-item'>
                <button
                  className='page-link'
                  onClick={() => setCurrentPage(totalPages)}
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className='page-link'
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label='Next'
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
